import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const ProductBadge = ({ status }: { status: string }) => {
  const { t } = useTranslation()
  
  switch (status) {
    case "DRAFT":
      return (
        <Badge
          h="1.5rem"
          lineHeight="1.5rem"
          px="1rem"
          rounded="xl"
          backgroundColor={"blue.50"}
          color={"blue.400"}
          border={"solid 1px"}
          borderColor={"blue.400"}
          textTransform={"capitalize"}
          w="fit-content"
        >
          {t('product.status.DRAFT')}
        </Badge>
      );
    case "INACTIVE":
      return (
        <Badge
          h="1.5rem"
          lineHeight="1.5rem"
          px="1rem"
          rounded="xl"
          backgroundColor={"gray.50"}
          color={"gray.400"}
          border={"solid 1px"}
          borderColor={"gray.400"}
          textTransform={"capitalize"}
          w="fit-content"
        >
          {t('product.status.INACTIVE')}
        </Badge>
      );
    case "ACTIVE":
      return (
        <Badge
          h="1.5rem"
          lineHeight="1.5rem"
          px="1rem"
          rounded="xl"
          backgroundColor={"green.50"}
          color={"green.400"}
          border={"solid 1px"}
          borderColor={"green.400"}
          textTransform={"capitalize"}
          w="fit-content"
        >
          {t('product.status.ACTIVE')}
        </Badge>
      );
    default:
      return <>---</>;
  }
};

export default ProductBadge;
